<template>
  <div
    class="           
    icono flex
    text-center
    justify-center
    content-center
    bg-transparent
    m-8 sm:m-4"
    :class="nombre"
    :style="{'height': height}"
  >
    <img 
      :src="ruta" 
      :alt="nombre"
    />
  </div>
</template>

<script>
export default {
  props: {    
    nombre:{
      type: String,
      requiered: false,
      default: ""
    },
    ruta: {
      type: String,
      requiered: false,
      default: "http://sponsor1"
    },
    height: {
      type: String,
      requiered: false,
      default: "6rem"
    }
  },
  data() {
    return {
      publicPath: process.env.BASE_URL
  }
},
mounted() {

}
};
</script>

<style scoped>

  .icono {
    height: 6rem;
  }

  .icono img {
    height: 100%;
    width: auto;
  }

@media screen and (min-width: 300px) { 

}

@media screen and (min-width: 480px) { 
  .icono {
    height: 4rem;
  }


}

@media screen and (min-width: 1300px) { 


}


</style>